import {useState} from "react";

export type IUseSidebar = {
    readonly open : boolean,
    readonly setOpen : (val:boolean)=> void;
}
const useSidebar = () : IUseSidebar=>{
    const [open,_setOpen] = useState<boolean>(true);

    const setOpen = (val:boolean)=>{
        _setOpen(val);
    }

    return{
        open,
        setOpen
    }
}

export default useSidebar;